import React, { Component, Suspense, lazy } from "react"
import PropTypes from "prop-types"
import { BrowserRouter as Router, Switch } from "react-router-dom"
import { connect } from "react-redux"
import { authProtectedRoutes, publicRoutes } from "./routes/"
import AppRoute from "./routes/route"

import NonAuthLayout from "./components/NonAuthLayout"
import LazyRouteLoader from "./components/Common/LazyRouteLoader"

const HorizontalLayout = lazy(() => import("./components/HorizontalLayout/"))
const VerticalLayout = lazy(() => import("./components/VerticalLayout/"))

// Import scss
import "./assets/scss/theme.scss"

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.getLayout = this.getLayout.bind(this)
  }

  componentDidMount() {
    const hasAuthUser = !!localStorage.getItem("authUser")
    const hasActiveSession = !!sessionStorage.getItem("activeSession")

    // sessionStorage survives refresh but is cleared when the tab/window closes
    if (hasAuthUser && !hasActiveSession) {
      localStorage.removeItem("authUser")
      localStorage.removeItem("userId")
      localStorage.removeItem("agentId")
      localStorage.removeItem("clientGuid")
      localStorage.removeItem("localData")
      return
    }

    if (hasAuthUser && hasActiveSession) {
      sessionStorage.setItem("activeSession", "true")
    }
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = HorizontalLayout
        break
    }
    return layoutCls
  }

  render() {
    const Layout = this.getLayout()

    return (
      <React.Fragment>
        <Router>
          <Suspense fallback={<LazyRouteLoader />}>
            <Switch>
              {publicRoutes.map((route, idx) => (
                <AppRoute
                  path={route.path}
                  layout={NonAuthLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={false}
                />
              ))}

              {authProtectedRoutes.map((route, idx) => (
                <AppRoute
                  path={route.path}
                  layout={Layout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                  exact
                />
              ))}
            </Switch>
          </Suspense>
        </Router>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

App.propTypes = {
  layout: PropTypes.object,
}

export default connect(mapStateToProps, null)(App)
